module.exports = __webpack_public_path__ + "img/excercise_tracker.09dd0806.png";